import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { AuthMethodCheckResponseDto } from '../../dto';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthApiService {
    constructor(private readonly baseApiService: BaseApiService) {
    }

    authMethodCheck(username: string): Observable<AuthMethodCheckResponseDto> {
        return this.baseApiService.get('auth/method-check', { params: { username }, showError: true });
    }
}
